const RatingStar = ({ rating }) => {
  function getImageUrl() {
    switch (true) {
      case rating < 2:
        return '/assets/images/red-star.svg';
      case rating < 3:
        return '/assets/images/orange-star.svg';
      case rating < 4:
        return '/assets/images/light-green-star.svg';
      case rating < 5:
        return '/assets/images/green-star.svg';
      default:
        return '/assets/images/dark-green-star.svg';
    }
  }

  return <img alt="Rating 5 Star" src={getImageUrl()} width={30} height={30} />;
};

export default RatingStar;
